import { render } from "./ClassList.vue?vue&type=template&id=65c38caa&scoped=true&ts=true"
import script from "./ClassList.vue?vue&type=script&lang=ts"
export * from "./ClassList.vue?vue&type=script&lang=ts"

import "./ClassList.vue?vue&type=style&index=0&id=65c38caa&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c38caa"]])

export default __exports__